import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { CustomText } from '@/components/CustomText';
import { Image } from 'expo-image';
import { GestureResponderEvent, ScrollView, StyleSheet, View } from 'react-native';
import React, { useContext, useState } from 'react';
import { CustomDivider } from "@/components/CustomDivider";
import {
  Anchor,
  AppBar,
  Button,
  Checkbox,
  Desktop,
  FAB,
  Fieldset,
  Hourglass,
  Label,
  List,
  NumberInput,
  Panel,
  Progress,
  Radio,
  SelectBox,
  Slider,
  Snackbar,
  Tabs,
  TextInput,
  Title,
  Toolbar,
  Window
} from 'react95-native-rabbl';
import Animated, { Easing, FadeIn, FadeOut, LayoutAnimationConfig } from 'react-native-reanimated';
import { AppContext } from '@/components/AppContext';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import { Link } from 'expo-router';
import Footer from '@/components/Footer';
import * as AppConsts from '@/utilities/AppConsts';
import { AppText95 } from '@/components/AppText95';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { RabblSearchResult } from "@/components/RabblSearchResult";
import Screenshots from "@/components/Screenshots";
import { BulletList } from '@/components/BulletList';
//import { GlitchImage } from 'rn-glitch-effect-rabbl';
import { AnimatedImage, Animation } from "@/components/AnimatedImage";
import { AllHomepagesFooter } from "@/components/AllHomepagesFooter";
import { Meta } from '@/components/Meta';

const BUTTERFLY_WIDTH = 150;
const BUTTERFLY_HEIGHT = 122;

const styles = StyleSheet.create({
  horizontal: {
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  horizontal2: {
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  horizontal3: {
    flexDirection: 'row',
    gap: 20,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingTop: 10,
  },
  centerAndPadding: {
    padding: 15,
    alignItems: 'center',
  },
  image: {
    width: 150,
    height: 150,
  },
  image99x99: {
    width: 99,
    height: 99,
  },
  image142x200: {
    width: 142,
    height: 200,
  },
  image220x309: {
    width: 220,
    height: 309,
  },
  fieldset: {
    gap: 20,
  },
  padding5: {
    padding: 5,
  },
  padding10: {
    padding: 10,
  },
  padding20: {
    padding: 20,
  },
  closeImage: {
  },
  butterflyImage: {
    width: BUTTERFLY_WIDTH,
    height: BUTTERFLY_HEIGHT,
  },
  panel: {
    padding: 20,
    gap: 20,
  },
  panelCentered: {
    padding: 20,
    gap: 20,
    alignItems: 'center',
  },
  panelWithTopMargin: {
    marginTop: 7,
  },
  w25h25: {
    width: 25,
    height: 25,
  },
  w20h21mh2: { 
    width: 20,
    height: 21,
    marginHorizontal: 2,
  },
  w15h16mh4: {
    width: 15,
    height: 16,
    marginHorizontal: 4,
  },
  w23h19: {
    width: 23,
    height: 19,
  },
  w24h24: {
    width: 24,
    height: 24,
  },
  flexRowJustifyCenter: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  w20h17mh2: {
    width: 20,
    height: 17,
    marginHorizontal: 2,
  },
  rabblsWrapper: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 50,
    justifyContent: 'center',
  },
  maxWidth: {
    maxWidth: AppConsts.MAX_WIDTH_COMFORTABLE_READING,
  },
});

export default function Index() {
  const [isMainWindowVisible, setIsMainWindowVisible] = useState(true);
  const highlighted_communities1 = useSelector((state: RootState) => state.user.highlighted_communities1);
  const loggedIn = useSelector((state: RootState) => state.user.loggedIn);

  const { explode } = useContext(AppContext);

  const closeMainWindow = (evt: GestureResponderEvent) => {
    explode(evt);

    setIsMainWindowVisible(false);
    setTimeout(() => {
      setIsMainWindowVisible(true);
    }, 2000);
  };

  return (
    <BasicScrollView center={true}>
      <Meta />

      <AnimatedImage
        source={require('@/assets/images/butterfly2.png')}
        style={styles.butterflyImage}
        width={BUTTERFLY_WIDTH}
        height={BUTTERFLY_HEIGHT}
        animation={Animation.UpAndDownTiming}
        duration={2000}
        //easing={Easing.inOut(Easing.poly(4))}
        easing={Easing.inOut(Easing.bezierFn(0.39, 0.02, 0.5, 1.41))}
      />

      {/*
      <Image
        source={require('@/assets/images/butterfly2.png')}
        style={styles.butterflyImage}
        contentFit="none"
      />
      */}

      {/*
      <GlitchImage
        shadowColor={'transparent'}
        mainColor={'transparent'}
        source={require('@/assets/images/butterfly2.png')}
        imageStyle={styles.butterflyImage}
      />
      */}

      <CustomText>Rabbl</CustomText>

      {isMainWindowVisible && (
        <Window title="Rabbl" onClose={closeMainWindow}>
          <View style={styles.centerAndPadding}>
            <Fieldset style={styles.fieldset}>
              <AppText95>Rabbl is a platform for dating communities.</AppText95>
              <View style={styles.horizontal}>
                <Link href="/findrabbl" asChild className={"nontext"}><Button>Find a Rabbl</Button></Link>
                <Link href="/rabbls" asChild className={"nontext"}><Button>Create a Rabbl</Button></Link>
              </View>
            </Fieldset>
          </View>
        </Window>
      )}

      <View style={AppConstants.STYLES.padding1} />

      <View style={styles.horizontal}>
        <Link href="/findrabbl" asChild={AppUtilities.isWeb()}>
          <Image
            source={require('@/assets/images/bunnylove.gif')}
            style={styles.image99x99}
          />
        </Link>
        <Link href="/findrabbl" asChild={AppUtilities.isWeb()}>
          <Image
            source={require('@/assets/images/lovechat.gif')}
            style={styles.image99x99}
          />
        </Link>
        <Link href="/findrabbl" asChild={AppUtilities.isWeb()}>
          <Image
            source={require('@/assets/images/lovecats.gif')}
            style={styles.image99x99}
          />
        </Link>
      </View>

      <View style={AppConstants.STYLES.padding2} />

      <Panel variant='raised' elevation={4} style={styles.maxWidth}>
        <View style={styles.panel}>
          <View style={AppConstants.STYLES.width100PAlignCenter}><CustomText>How it works</CustomText></View>
          <CustomDivider fullWidth={true} />
          <CustomText>For daters</CustomText>
          <BulletList
            data={[
              { content: "Join dating communities of like-minded people." },
              { content: "No gimmicks. Unlimited free likes and messages." },
              { content: "Pay a one-time cover charge per community just like a club. This keeps out most scammers and funds creators." },
            ]}
          />
          <View style={AppConstants.STYLES.padding2} />
          <View style={styles.flexRowJustifyCenter}><Link href="/findrabbl" asChild className={"nontext"}><Button>Find a Rabbl</Button></Link></View>
          <View style={AppConstants.STYLES.padding2} />
          <CustomDivider fullWidth={true} />
          <CustomText>For creators</CustomText>
          <BulletList
            data={AppUtils.CREATOR_BULLETS_NO_BOLD}
            bulletStart={3}
          />
          <View style={AppConstants.STYLES.padding2} />
          <View style={styles.flexRowJustifyCenter}><Link href="/rabbls" asChild className={"nontext"}><Button>Create a Rabbl</Button></Link></View>
        </View>
      </Panel>

      {
        !loggedIn &&
          <>
            <View style={AppConstants.STYLES.padding10} />

            <Panel variant='raised' elevation={4} style={styles.panelWithTopMargin}>
              <View style={styles.panel}>
                <View style={AppConstants.STYLES.alignCenter}><CustomText>Account</CustomText></View>
                <Link href="/signin" asChild className={"nontext"}><Button size="lg">{AppConsts.EXISING_USERS_LOGIN}</Button></Link>
                <Link href="/signup" asChild className={"nontext"}><Button size="lg">Create account</Button></Link>
              </View>
            </Panel>
          </>
      }

      <View style={AppConstants.STYLES.padding5} />

      <Screenshots />

      <View style={AppConstants.STYLES.padding10} />

      <Panel variant='raised' elevation={4} style={styles.panelWithTopMargin}>
        <View style={styles.panel}>
          <View style={AppConstants.STYLES.width100PAlignCenter}><CustomText>Highlighted Rabbls</CustomText></View>
          <CustomDivider fullWidth={true} />
          <View style={styles.rabblsWrapper}>
            {highlighted_communities1.map((c) => (
              <View key={c.id}>
                <RabblSearchResult community={c} />
              </View>
            ))}
          </View>
          <View style={styles.horizontal3}>
            <Link href="/findrabbl" asChild className={"nontext"}><Button>Show more Rabbls</Button></Link>
            <Link href="/rabbls" asChild className={"nontext"}><Button>Create a Rabbl</Button></Link>
          </View>
        </View>
      </Panel>

      {
        !loggedIn &&
          <>
            <View style={AppConstants.STYLES.padding10} />

            <Panel variant='raised' elevation={4} style={styles.panelWithTopMargin}>
              <View style={styles.panel}>
                <View style={AppConstants.STYLES.alignCenter}><CustomText>Account</CustomText></View>
                <Link href="/signin" asChild className={"nontext"}><Button size="lg">{AppConsts.EXISING_USERS_LOGIN}</Button></Link>
                <Link href="/signup" asChild className={"nontext"}><Button size="lg">Create account</Button></Link>
              </View>
            </Panel>
          </>
      }

      <AllHomepagesFooter />

      <Footer home={false} />
    </BasicScrollView>
  );
}
